(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shg-ai-103830d8c5-published"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  // Add click handlers for grid images to open modal
  document.addEventListener('DOMContentLoaded', function() {
    const gridItems = document.querySelectorAll('.product__media-grid-item[data-media-id]');
    const modal = document.querySelector('#ProductModal-{{ section.id }}');
    
    gridItems.forEach(item => {
      item.addEventListener('click', function() {
        if (modal && modal.show) {
          modal.show(this);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shg-ai-103830d8c5-temp"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  // Add click handlers for grid images to open modal
  document.addEventListener('DOMContentLoaded', function() {
    const gridItems = document.querySelectorAll('.product__media-grid-item[data-media-id]');
    const modal = document.querySelector('#ProductModal-{{ section.id }}');
    
    gridItems.forEach(item => {
      item.addEventListener('click', function() {
        if (modal && modal.show) {
          modal.show(this);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shg-ai-5c0420361b-published"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const showcaseContainers = document.querySelectorAll('.product-showcase[data-section-id]');
    
    showcaseContainers.forEach(container => {
      const hotspots = container.querySelectorAll('.product-showcase__hotspot');
      const features = container.querySelectorAll('.product-showcase__feature');
      const addToCartButtons = container.querySelectorAll('.product-showcase__add-to-cart[data-variant-id]');
      
      function handleHotspotClick(event) {
        const clickedHotspot = event.currentTarget;
        const hotspotId = clickedHotspot.dataset.hotspot;
        
        // Remove active class from all hotspots and features in this container
        hotspots.forEach(hotspot => hotspot.classList.remove('active'));
        features.forEach(feature => {
          feature.classList.remove('active');
          feature.style.display = 'none';
        });
        
        // Add active class to clicked hotspot
        clickedHotspot.classList.add('active');
        
        // Show corresponding feature with fade effect
        const targetFeature = container.querySelector(`[data-feature="${hotspotId}"]`);
        if (targetFeature) {
          targetFeature.style.display = 'block';
          // Force reflow to ensure display change is applied
          targetFeature.offsetHeight;
          targetFeature.classList.add('active');
        }
      }
      
      function handleAddToCart(event) {
        const button = event.currentTarget;
        const variantId = button.dataset.variantId;
        const productTitle = button.dataset.productTitle;
        
        if (!variantId || button.disabled) return;
        
        // Add loading state
        button.classList.add('loading');
        const originalText = button.textContent;
        button.textContent = 'Adding...';
        
        // Prepare form data
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        
        // Add to cart via AJAX
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Remove loading state
          button.classList.remove('loading');
          button.textContent = originalText;
          
          // Trigger cart drawer open
          if (window.theme && window.theme.openCartDrawer) {
            window.theme.openCartDrawer();
          } else if (document.querySelector('[data-cart-drawer]')) {
            // Try alternative cart drawer methods
            const cartDrawer = document.querySelector('[data-cart-drawer]');
            if (cartDrawer) {
              cartDrawer.classList.add('active');
            }
          } else if (document.querySelector('.cart-drawer')) {
            const cartDrawer = document.querySelector('.cart-drawer');
            if (cartDrawer) {
              cartDrawer.classList.add('is-open');
            }
          }
          
          // Update cart count if exists
          const cartCount = document.querySelector('[data-cart-count]');
          if (cartCount && data.quantity) {
            cartCount.textContent = data.quantity;
          }
          
          // Dispatch custom event for cart update
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { item: data }
          }));
          
          // Show success feedback
          button.textContent = 'Added!';
          setTimeout(() => {
            button.textContent = originalText;
          }, 2000);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          
          // Remove loading state
          button.classList.remove('loading');
          button.textContent = originalText;
          
          // Show error feedback
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = originalText;
          }, 2000);
        });
      }
      
      // Add event listeners to hotspots
      hotspots.forEach(hotspot => {
        hotspot.addEventListener('click', handleHotspotClick);
      });
      
      // Add event listeners to add to cart buttons
      addToCartButtons.forEach(button => {
        button.addEventListener('click', handleAddToCart);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shg-ai-5c0420361b-temp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    'use strict';
    
    const initProductShowcase = () => {
      const showcaseContainers = document.querySelectorAll('.product-showcase[data-section-id]');
      
      showcaseContainers.forEach(container => {
        // Skip if already initialized
        if (container.dataset.initialized) return;
        container.dataset.initialized = 'true';
        
        const hotspots = container.querySelectorAll('.product-showcase__hotspot');
        const features = container.querySelectorAll('.product-showcase__feature');
        const addToCartButtons = container.querySelectorAll('.product-showcase__add-to-cart[data-variant-id]');
        
        // Cache frequently accessed elements
        const cartCountElement = document.querySelector('[data-cart-count]');
        
        const handleHotspotClick = (event) => {
          const clickedHotspot = event.currentTarget;
          const hotspotId = clickedHotspot.dataset.hotspot;
          
          // Use more efficient class operations
          hotspots.forEach(hotspot => hotspot.classList.remove('active'));
          features.forEach(feature => {
            if (feature.classList.contains('active')) {
              feature.classList.remove('active');
              feature.style.display = 'none';
            }
          });
          
          clickedHotspot.classList.add('active');
          
          const targetFeature = container.querySelector(`[data-feature="${hotspotId}"]`);
          if (targetFeature) {
            targetFeature.style.display = 'block';
            targetFeature.offsetHeight; // Force reflow
            targetFeature.classList.add('active');
          }
        };
        
        const handleAddToCart = async (event) => {
          const button = event.currentTarget;
          const variantId = button.dataset.variantId;
          
          if (!variantId || button.disabled || button.classList.contains('loading')) return;
          
          button.classList.add('loading');
          const originalText = button.textContent;
          button.textContent = 'Adding...';
          
          try {
            const formData = new FormData();
            formData.append('id', variantId);
            formData.append('quantity', '1');
            
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              body: formData
            });
            
            if (!response.ok) throw new Error('Network response was not ok');
            
            const data = await response.json();
            
            // Try multiple cart drawer opening methods
            if (window.theme?.openCartDrawer) {
              window.theme.openCartDrawer();
            } else {
              const cartDrawer = document.querySelector('[data-cart-drawer], .cart-drawer');
              if (cartDrawer) {
                cartDrawer.classList.add('active', 'is-open');
              }
            }
            
            // Update cart count efficiently
            if (cartCountElement && data.quantity) {
              cartCountElement.textContent = data.quantity;
            }
            
            // Dispatch event for theme compatibility
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { item: data }
            }));
            
            // Success feedback
            button.textContent = 'Added!';
            setTimeout(() => {
              button.textContent = originalText;
            }, 2000);
            
          } catch (error) {
            console.error('Error adding to cart:', error);
            button.textContent = 'Error';
            setTimeout(() => {
              button.textContent = originalText;
            }, 2000);
          } finally {
            button.classList.remove('loading');
          }
        };
        
        // Use event delegation for better performance
        container.addEventListener('click', (event) => {
          if (event.target.classList.contains('product-showcase__hotspot')) {
            handleHotspotClick(event);
          } else if (event.target.classList.contains('product-showcase__add-to-cart') && 
                     event.target.dataset.variantId) {
            handleAddToCart(event);
          }
        });
      });
    };
    
    // Initialize immediately if DOM is ready, otherwise wait
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initProductShowcase);
    } else {
      initProductShowcase();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shg-ai-8deb835da2-published"] && !Shopify.designMode) return;
  try {
    
class ImageComparison {
  constructor(element) {
    this.element = element;
    this.container = element.querySelector('.image-comparison__container');
    this.imageWrapper = element.querySelector('.image-comparison__image-wrapper');
    this.slider = element.querySelector('.image-comparison__slider');
    this.handle = element.querySelector('.image-comparison__handle');
    this.afterImage = element.querySelector('.image-comparison__image--after');
    this.beforeImage = element.querySelector('.image-comparison__image--before');
    
    this.isDragging = false;
    this.position = 50; // Start at 50%
    
    this.init();
  }
  
  init() {
    if (!this.container || !this.slider || !this.handle) return;
    
    this.setupImageSizing();
    this.bindEvents();
    this.updatePosition(this.position);
    
    // Remove loading state
    this.element.classList.remove('image-comparison--loading');
    
    // Handle image load events to resize container
    const images = this.element.querySelectorAll('.image-comparison__image');
    images.forEach(img => {
      if (img.complete) {
        this.updateContainerSize();
      } else {
        img.addEventListener('load', () => this.updateContainerSize());
      }
    });
  }
  
  setupImageSizing() {
    // Ensure both images are the same size for proper comparison
    if (this.beforeImage && this.afterImage) {
      const beforeRect = this.beforeImage.getBoundingClientRect();
      const afterRect = this.afterImage.getBoundingClientRect();
      
      // Set container height based on images
      this.updateContainerSize();
    }
  }
  
  updateContainerSize() {
    if (!this.beforeImage || !this.afterImage) return;
    
    // Get the natural dimensions of both images
    const beforeAspect = this.beforeImage.naturalWidth / this.beforeImage.naturalHeight;
    const afterAspect = this.afterImage.naturalWidth / this.afterImage.naturalHeight;
    
    // Use the aspect ratio of the first image, or average if they're different
    const targetAspect = beforeAspect;
    
    // Calculate container size based on available width
    const containerWidth = this.container.offsetWidth;
    const containerHeight = containerWidth / targetAspect;
    
    // Set minimum height but allow images to determine optimal size
    const minHeight = 300;
    const finalHeight = Math.max(minHeight, Math.min(containerHeight, 600));
    
    this.container.style.height = finalHeight + 'px';
    this.imageWrapper.style.height = finalHeight + 'px';
  }
  
  bindEvents() {
    // Mouse events
    this.handle.addEventListener('mousedown', this.startDrag.bind(this));
    this.slider.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.onDrag.bind(this));
    document.addEventListener('mouseup', this.endDrag.bind(this));
    
    // Touch events
    this.handle.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    this.slider.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
    document.addEventListener('touchend', this.endDrag.bind(this));
    
    // Keyboard events for accessibility
    this.handle.addEventListener('keydown', this.onKeyDown.bind(this));
    
    // Click on container to jump to position
    this.container.addEventListener('click', this.onContainerClick.bind(this));
    
    // Prevent context menu on handle
    this.handle.addEventListener('contextmenu', (e) => e.preventDefault());
    
    // Handle window resize
    window.addEventListener('resize', this.debounce(() => {
      this.updateContainerSize();
    }, 250));
  }
  
  startDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.element.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
    
    // Add visual feedback
    this.handle.style.transform = 'translate(-50%, -50%) scale(0.95)';
  }
  
  onDrag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    
    const rect = this.container.getBoundingClientRect();
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    
    this.updatePosition(percentage);
  }
  
  endDrag() {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.element.style.cursor = '';
    document.body.style.userSelect = '';
    
    // Remove visual feedback
    this.handle.style.transform = 'translate(-50%, -50%)';
  }
  
  onKeyDown(e) {
    const step = e.shiftKey ? 10 : 1;
    
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        this.updatePosition(Math.max(0, this.position - step));
        break;
      case 'ArrowRight':
        e.preventDefault();
        this.updatePosition(Math.min(100, this.position + step));
        break;
      case 'Home':
        e.preventDefault();
        this.updatePosition(0);
        break;
      case 'End':
        e.preventDefault();
        this.updatePosition(100);
        break;
    }
  }
  
  onContainerClick(e) {
    if (this.isDragging || e.target === this.handle || e.target === this.slider) return;
    
    const rect = this.container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    this.updatePosition(percentage);
  }
  
  updatePosition(percentage) {
    this.position = Math.max(0, Math.min(100, percentage));
    
    // Update slider position
    this.slider.style.left = `${this.position}%`;
    
    // Update clip path for after image - fixed clipping logic
    if (this.afterImage) {
      this.afterImage.style.clipPath = `inset(0 0 0 ${this.position}%)`;
    }
    
    // Update ARIA attributes
    this.handle.setAttribute('aria-valuenow', Math.round(this.position));
  }
  
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize all image comparison components
document.addEventListener('DOMContentLoaded', () => {
  const imageComparisons = document.querySelectorAll('.image-comparison');
  imageComparisons.forEach(element => {
    new ImageComparison(element);
  });
});

// Handle theme editor updates
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const imageComparison = e.target.querySelector('.image-comparison');
    if (imageComparison) {
      new ImageComparison(imageComparison);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shg-ai-8deb835da2-temp"] && !Shopify.designMode) return;
  try {
    
class ImageComparison {
  constructor(element) {
    this.element = element;
    this.container = element.querySelector('.image-comparison__container');
    this.imageWrapper = element.querySelector('.image-comparison__image-wrapper');
    this.slider = element.querySelector('.image-comparison__slider');
    this.handle = element.querySelector('.image-comparison__handle');
    this.afterImage = element.querySelector('.image-comparison__image--after');
    this.beforeImage = element.querySelector('.image-comparison__image--before');
    
    this.isDragging = false;
    this.position = 50; // Start at 50%
    
    this.init();
  }
  
  init() {
    if (!this.container || !this.slider || !this.handle) return;
    
    this.setupImageSizing();
    this.bindEvents();
    this.updatePosition(this.position);
    
    // Remove loading state
    this.element.classList.remove('image-comparison--loading');
    
    // Handle image load events to resize container
    const images = this.element.querySelectorAll('.image-comparison__image');
    images.forEach(img => {
      if (img.complete) {
        this.updateContainerSize();
      } else {
        img.addEventListener('load', () => this.updateContainerSize());
      }
    });
  }
  
  setupImageSizing() {
    // Ensure both images are the same size for proper comparison
    if (this.beforeImage && this.afterImage) {
      const beforeRect = this.beforeImage.getBoundingClientRect();
      const afterRect = this.afterImage.getBoundingClientRect();
      
      // Set container height based on images
      this.updateContainerSize();
    }
  }
  
  updateContainerSize() {
    if (!this.beforeImage || !this.afterImage) return;
    
    // Get the natural dimensions of both images
    const beforeAspect = this.beforeImage.naturalWidth / this.beforeImage.naturalHeight;
    const afterAspect = this.afterImage.naturalWidth / this.afterImage.naturalHeight;
    
    // Use the aspect ratio of the first image, or average if they're different
    const targetAspect = beforeAspect;
    
    // Calculate container size based on available width
    const containerWidth = this.container.offsetWidth;
    const containerHeight = containerWidth / targetAspect;
    
    // Set minimum height but allow images to determine optimal size
    const minHeight = 300;
    const finalHeight = Math.max(minHeight, Math.min(containerHeight, 600));
    
    this.container.style.height = finalHeight + 'px';
    this.imageWrapper.style.height = finalHeight + 'px';
  }
  
  bindEvents() {
    // Mouse events
    this.handle.addEventListener('mousedown', this.startDrag.bind(this));
    this.slider.addEventListener('mousedown', this.startDrag.bind(this));
    document.addEventListener('mousemove', this.onDrag.bind(this));
    document.addEventListener('mouseup', this.endDrag.bind(this));
    
    // Touch events
    this.handle.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    this.slider.addEventListener('touchstart', this.startDrag.bind(this), { passive: false });
    document.addEventListener('touchmove', this.onDrag.bind(this), { passive: false });
    document.addEventListener('touchend', this.endDrag.bind(this));
    
    // Keyboard events for accessibility
    this.handle.addEventListener('keydown', this.onKeyDown.bind(this));
    
    // Click on container to jump to position
    this.container.addEventListener('click', this.onContainerClick.bind(this));
    
    // Prevent context menu on handle
    this.handle.addEventListener('contextmenu', (e) => e.preventDefault());
    
    // Handle window resize
    window.addEventListener('resize', this.debounce(() => {
      this.updateContainerSize();
    }, 250));
  }
  
  startDrag(e) {
    e.preventDefault();
    this.isDragging = true;
    this.element.style.cursor = 'ew-resize';
    document.body.style.userSelect = 'none';
    
    // Add visual feedback
    this.handle.style.transform = 'translate(-50%, -50%) scale(0.95)';
  }
  
  onDrag(e) {
    if (!this.isDragging) return;
    
    e.preventDefault();
    
    const rect = this.container.getBoundingClientRect();
    const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
    const x = clientX - rect.left;
    const percentage = Math.max(0, Math.min(100, (x / rect.width) * 100));
    
    this.updatePosition(percentage);
  }
  
  endDrag() {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.element.style.cursor = '';
    document.body.style.userSelect = '';
    
    // Remove visual feedback
    this.handle.style.transform = 'translate(-50%, -50%)';
  }
  
  onKeyDown(e) {
    const step = e.shiftKey ? 10 : 1;
    
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        this.updatePosition(Math.max(0, this.position - step));
        break;
      case 'ArrowRight':
        e.preventDefault();
        this.updatePosition(Math.min(100, this.position + step));
        break;
      case 'Home':
        e.preventDefault();
        this.updatePosition(0);
        break;
      case 'End':
        e.preventDefault();
        this.updatePosition(100);
        break;
    }
  }
  
  onContainerClick(e) {
    if (this.isDragging || e.target === this.handle || e.target === this.slider) return;
    
    const rect = this.container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const percentage = (x / rect.width) * 100;
    
    this.updatePosition(percentage);
  }
  
  updatePosition(percentage) {
    this.position = Math.max(0, Math.min(100, percentage));
    
    // Update slider position
    this.slider.style.left = `${this.position}%`;
    
    // Update clip path for after image - fixed clipping logic
    if (this.afterImage) {
      this.afterImage.style.clipPath = `inset(0 0 0 ${this.position}%)`;
    }
    
    // Update ARIA attributes
    this.handle.setAttribute('aria-valuenow', Math.round(this.position));
  }
  
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

// Initialize all image comparison components
document.addEventListener('DOMContentLoaded', () => {
  const imageComparisons = document.querySelectorAll('.image-comparison');
  imageComparisons.forEach(element => {
    new ImageComparison(element);
  });
});

// Handle theme editor updates
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const imageComparison = e.target.querySelector('.image-comparison');
    if (imageComparison) {
      new ImageComparison(imageComparison);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
